/**
 * ä¸´æ¶æéä¿¡æ¯å¯¹è±¡
 */
export class Credentials {
  tmpSecretId: string;
  tmpSecretKey: string;
  sessionToken: string;
}
